<script lang="ts">
  import { Inspector, InspectorSection } from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import type { Status, StatusView } from "../../services/models"
  import {default as StatusViewComponent} from "./StatusView.svelte"
  
  export let status: StatusView;
  export let inspector: any;

  function close(event) {
    if(event.key === "Escape") {
      inspector.close()
    }
  }
</script>

<svelte:window
    on:keyup={close}
/>

<Inspector title={ $_("common.status") } bind:this={inspector} on:close={() => status = undefined}>
  {#if status }
  <InspectorSection title={ $_("common.status") }>
    <StatusViewComponent bind:status={status.status}></StatusViewComponent>
  </InspectorSection>

  <InspectorSection title={ $_("common.history") }>
    {#each status.statusHistory.sort((a,b) => a.timestamp > b.timestamp ? -1 : 1) as s}
    <StatusViewComponent bind:status={s}></StatusViewComponent>
    {/each}
  </InspectorSection>
  {/if}
</Inspector>

<style>
  :global(.gl-inspector) {
    min-width: 40rem;
  }
</style>